import {bootstrapApplication} from '@angular/platform-browser';
import {appConfig} from './app/app.config';
import {AppComponent} from './app/app.component';
import {isNative} from "./app/utils";
import {CapacitorUpdater} from "@capgo/capacitor-updater";
import 'zone.js/plugins/task-tracking';
CapacitorUpdater.notifyAppReady();

performance.mark('start-app');

if (!isNative) {
    // GenericOAuth2.redirectFlowCodeListener({
    //   ...cognitoOptions,
    //   response_url: cognitoOptions.web!.redirectUrl!,
    // })
    //   .catch(
    //   (error) => console.warn('Error in redirectFlowCodeListener:', error)
    // );
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err))
  .finally(() => {
    performance.mark('end-app');
    performance.measure('app-initialization', 'start-app', 'end-app');

    const measures = performance.getEntriesByName('app-initialization');
    console.log(`App Initialization Time: ${measures[0]?.duration}ms`);
  });
